var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionLink',{staticClass:"back-button",attrs:{"icon":"arrowLeft","size":_vm.size},on:{"click":_vm.goBack}})}
var staticRenderFns = []

export { render, staticRenderFns }